<template lang="pug">
  .grid-wrap
    header.d-flex.justify-content-between(v-if="options.title")
      h2 {{ options.title }}
    b-row.search-form(v-if="options.checked")
      b-col
      b-col.right-btns
        b-btn(size="sm" @click="showDialogUser = true") {{$t('user_page.add_department_member')}}
        b-btn.ml-2.view-mode-button(size="sm" :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}     
          span(v-else) Download...
        b-btn.ml-2(size="sm" variant="primary" @click="selectDelete(allChecked)") {{$t('user_page.select_exclude')}}
    b-card.table-card
      b-table(
        ref="userTable",
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="name"
        :sort-desc="false"
        show-empty
        responsive
      )
        //- header
        template(v-if="options.checked" v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @input="selectAllRows")
          
        //- body
        template(v-if="options.checked" v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item.isSelected" @change="handleCheck(row.item)")

        template(v-slot:cell(user_type)="row")
          span.member-type-icon(v-if="row.item.user_type === 2 || row.item.user_type === 3") S
          span.member-type-icon(v-if="row.item.user_type === 6") A

        template(v-slot:cell(id)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.id}}
        
        template(v-slot:cell(name)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.name}}
        
        template(v-slot:cell(auth_filemanager)="row")
          switches.lmm-switch(
            v-model="row.item.auth_filemanager",
            theme="bootstrap",
            :disabled="true"
            :color="row.item.auth_filemanager ? 'primary' : 'default'",
            @change.native="handleChange('auth_filemanager', $event, row.item.user_fk)"
          )
        
        template(v-slot:cell(flag_use_approval)="row")
          switches.lmm-switch(
            v-model="row.item.flag_use_approval",
            theme="bootstrap",
            :disabled="true"
            :color="row.item.flag_use_approval ? 'primary' : 'default'",
            @change.native="handleChange('flag_use_approval', $event, row.item.user_fk)"
          )
        
        template(v-slot:cell(post_approval)="row")
          switches.lmm-switch(
            v-model="row.item.post_approval",
            theme="bootstrap",
            :color="row.item.post_approval ? 'primary' : 'default'",
            @change.native="handleChange('post_approval', $event, row.item.user_fk)"
          )
        
        template(v-slot:cell(flag_active)="row")
          switches.lmm-switch(
            v-model="row.item.flag_active",
            theme="bootstrap",
            :disabled="true"
            :color="row.item.flag_active ? 'primary' : 'default'",
            @change.native="handleChange('auth_remotecontrol', $event, row.item.user_fk)"
          )
        
        template(v-slot:cell(delete)="row")
          b-link.d-inline-flex(size="sm" @click="selectDelete([row.item])") #[span.svg-icon.trash delete]

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )

    confirm-dialogs(:show.sync="showDelete" :option="{ size: 'md', title: this.$t('user_page.exclude_department_members') }")
      .warning
        icon.icon(name="exclamation-triangle" width="50" height="50")
        span ※ Warning ※
      .msg(v-html="$t('user_page.confirm_user_exclusion', { departmentName: departmentName })")
      .box
        .select
          span(v-for="item of deleteList" :key="item.pk") "{{ item.name }}({{ item.id }})"
        .msg(v-html="$t('user_page.excluded_user_temp_department')")
      .bottom-btns
        b-btn(size="sm" variant="danger" @click="del" pill) {{$t('user_page.exclude')}}
        b-btn.btn-secondary(size="sm" @click="showDelete = false" pill) {{$t('cancel')}}

    dialog-manager(
      :show.sync="showDialogUser"
      :title="String(this.$t('user_page.add_department_member'))"
      :data="{ context: 'department_users_list_modal', department_fk: pk }"
      @select="selectUser"
    )
</template>

<script>
import { DepartmentsAPI, GetMgridAPI } from "@/api"
import Switches from "vue-switches"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"
import _ from "lodash"
import DialogManager from "@/components/dialogs/dialogManager.vue"

export default {
  props: {
    departmentName: {
      type: String,
      default: null,
    },
    pk: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Object,
      default: () => ({
        title: null,
        checked: false,
      }),
    },
  },
  components: {
    Switches,
    ConfirmDialogs,
    DialogManager,
  },
  data() {
    return {
      excelLoaded: false,
      showDelete: false,
      showDialogUser: false,

      allSelected: false,
      allChecked: [],
      deleteList: [],
      tableData: {
        fields: [
          // TODO: user_type 값 없음
          { key: "user_type", label: this.$t("admin_privileges"), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "id", label: this.$t("ID"), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "name", label: this.$t('account-manage'), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "auth_filemanager", label: this.$t('function-settings03'), sortable: true, thStyle: { minWidth: "100px" } },
          { key: "flag_use_approval", label: this.$t('user_page.approval_process'), sortable: true, thStyle: { minWidth: "140px" } },
          { key: "post_approval", label: this.$t('post_approval'), sortable: true, thStyle: { minWidth: "140px" } },
          { key: "flag_active", label: this.$t('active'), sortable: true, thStyle: { minWidth: "80px" } },
        ],
        list: [],
        pagination: {
          by: "name",
          limit: 24,
          offset: 0,
          order: "desc",
          search_mode: "pagination",

          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },
    }
  },
  methods: {
    fetchList(ctx) {
      if (!ctx) return
      if (ctx.sortBy === "") return
      if (this.options.checked) {
        this.tableData.fields.unshift({
          key: "check",
          label: "",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "1%" },
        })
        this.tableData.fields.push({ key: "delete", label: this.$t('user_page.exclude'), thClass: "text-center", tdClass: "text-center", thStyle: { minWidth: "80px" } })
      }

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      const params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        search_mode: "pagination",
      }

      return DepartmentsAPI.get(`user/${String(this.pk)}`, { params }).then(res => {
        const { objects, meta } = res.data

        this.tableData.list = objects
        this.tableData.pagination.total = meta.total_count
        return this.tableData.list
      })
    },
    handleCheck(item) {
      if (this.allChecked.includes(item)) {
        const index = this.allChecked.findIndex(u => u.pk === item.pk)
        this.allChecked.splice(index, 1)
      }
      if (item.isSelected) {
        this.allChecked.push(item)
      }
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        v.isSelected = this.allSelected
        this.handleCheck(v)
      })
    },
    selectDelete(items) {
      if (items.length === 0) {
        this.$bvToast.toast(this.$t('toasts_message.no_selected_department_members'), {
          title: "Warning",
          variant: "warning",
          solid: true,
        })
        return
      }
      this.deleteList = _.cloneDeep(items)
      this.showDelete = true
    },
    handleChange(key, event, pk) {
      let params = {
        request_type: 1,
        user_fk: pk,
      }
      params[key] = event.target.checked ? 1 : 0
      DepartmentsAPI.put(`user/${this.pk}`, params)
    },
    async del() {
      for (const item of this.deleteList) {
        const params = {
          // input_type: "department_user_delete",
          flag_delete: 1,
          user_fk: item.user_fk,
        }
        await DepartmentsAPI.put(`user/${this.pk}`, params)
      }
      this.showDelete = false
      this.$refs.userTable.refresh()
    },
    selectUser(users) {
      this.showDialogUser = false
      const params = {
        user_fk: users.map(u => u.pk),
      }
      DepartmentsAPI.post(`user/${this.pk}`, params).then(res => {
        this.$refs.userTable.refresh()
      })
    },
    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
          return
        })
    },
    async fetchExcel() {
      if (this.tableData.pagination.total < 1) {
        throw new Error(this.$t('no_data_available'))
      }
      let params = {
        by: this.tableData.pagination.by,
        limit: 0,
        offset: 0,
        order: this.tableData.pagination.order,
      }

      const list = await DepartmentsAPI.get(`user/${String(this.pk)}`, { params })
      const excelParams = list.data
      excelParams.excel_doc_title = this.$t('user_page.department_management_department_members')

      //console.log(excelParams.objects)
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "user_departuser"
      excelParams_for_download.excel_doc_title = this.$t('user_page.department_management_department_members')

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let output = []
      let auth_filemanager = {
        "0": "X",
        "1": "O",
      }
      let flag_use_approval = {
        false: "X",
        true: "O",
      }
      let post_approval = {
        false: "X",
        true: "O",
      }
      let flag_active = {
        false: "X",
        true: "O",
      }
      let user_type = {
        "1": this.$t('user'),
        "2": this.$t('policy_manager'),
        "3": this.$t('policy_manager'),
        "6": this.$t('mid_manager'),
      }
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('admin_privileges')]: user_type[input[index]["user_type"]],
          [this.$t('ID')]: input[index]["id"],
          [this.$t('name')]: input[index]["name"],
          [this.$t('function-settings03')]: auth_filemanager[input[index]["auth_filemanager"]],
          [this.$t('user_page.approval_process')]: flag_use_approval[input[index]["flag_use_approval"]],
          [this.$t('post_approval')]: post_approval[input[index]["post_approval"]],
          [this.$t('active')]: flag_active[input[index]["flag_active"]],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-wrap {
  padding-top: 10px;
}
header {
  padding: 30px 0 10px 5px;
  h2 {
    font-size: 1.2rem;
  }
  .btns {
    button + button {
      margin-left: 10px;
    }
  }
}
</style>
